import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'nivel-cliente');

const nivelProdutoActions = {
  ...genericActions(basePath),
  orcamento: { method: 'GET', url: `${basePath}/orcamento` },
  acao: { method: 'GET', url: `${basePath}/acao` },
};

export default resource => resource(`${basePath}`, {}, nivelProdutoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/nivel-cliente.js